(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exoroot-product"]) return;
  try {
    
  (() => {
    function init(root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const strings = JSON.parse(root.querySelector('[data-ex2-strings]').textContent);
      const form = root.querySelector('form');
      const radios = root.querySelectorAll('input[type="radio"]');
      const submit = root.querySelector('[data-ex2-submit]');
      const sticky = root.querySelector('[data-ex2-sticky-button]');
      const status = root.querySelector('[data-ex2-status]');
      const currency = new Intl.NumberFormat(root.dataset.locale, { style:'currency',currency:root.dataset.currency });
      function update() {
        const radio = root.querySelector('input[type="radio"]:checked');
        if (!radio) return;
        const isSub = radio.dataset.kind === 'subscription';
        const ready = !isSub || radio.dataset.ready === 'true';
        const available = ready && radio.dataset.available === 'true';
        const price = currency.format(Number(radio.dataset.price)/100) + ' ' + root.dataset.currency;
        const label = !ready ? strings.soon : !available ? strings.sold : isSub ? strings.subscribe : strings.add;
        root.querySelector('[data-ex2-id]').value = radio.value;
        const plan = root.querySelector('[data-ex2-plan]');
        plan.value = radio.dataset.plan || '';
        plan.disabled = !isSub || !ready;
        root.querySelector('[data-ex2-total]').textContent = price;
        root.querySelector('[data-ex2-sticky-price]').textContent = price;
        root.querySelector('[data-ex2-summary]').textContent = strings[radio.dataset.kind];
        root.querySelector('[data-ex2-sticky-summary]').textContent = strings[radio.dataset.kind];
        root.querySelector('[data-ex2-terms]').hidden = !isSub;
        root.querySelector('[data-ex2-cta-text]').textContent = label;
        sticky.textContent = label;
        submit.disabled = !available;
        sticky.disabled = !available;
        status.textContent = '';
      }
      radios.forEach(radio => radio.addEventListener('change', update));
      root.querySelectorAll('[data-ex2-image]').forEach(button => button.addEventListener('click', () => {
        const image = root.querySelector('.ex2__main-image');
        image.removeAttribute('srcset');
        image.src = button.dataset.ex2Image;
        root.querySelectorAll('[data-ex2-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      sticky.addEventListener('click', () => form.requestSubmit(submit));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (submit.disabled) return;
        submit.disabled = true;
        sticky.disabled = true;
        root.querySelector('[data-ex2-cta-text]').textContent = strings.adding;
        const data = new FormData(form);
        try {
          const response = await fetch(root.dataset.cartAdd, {method:'POST',body:data,headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : strings.error);
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          update();
          status.textContent = error.message || strings.error;
        }
      });
      update();
    }
    document.querySelectorAll('[data-ex2]').forEach(init);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ex2]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
